<span class="label">Session Timeout:</span>
<span class="time">{{ timeLeft | formatTimer }} min</span>
<button class="reset" title="Reset" (click)="resetTimer()"></button>
